import {
  Typography,
  Box,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material'
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material'

import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'
import { NumberInput } from '../../../components/NumberInput'
import './UsageCustomImplantModal.scss'
import { UsageCustomImplantModalProps } from './UsageCustomImplantModel.types'
import useUsageCustomImplantModalLogic from './UsageCustomImplantModal.logic'

const UsageCustomImplantModal = ({
  open,
  onClose,
  implant,
}: UsageCustomImplantModalProps) => {
  const {
    isSingleImplant = false,
    isWasted = false,
    usageCount = 0,
    maxCount = 0,
    handleConfirm = () => {},
    isLoading = false,
    setIsWasted = () => {},
    setUsageCount = () => {},
  } = useUsageCustomImplantModalLogic({
    implant,
    onClose,
    open,
  }) || {}

  if (!implant) return null

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="usage-custom-implant-modal-wrapper"
    >
      <div className="usage-custom-implant-modal">
        <div className="header-box">
          <CheckCircleIcon />
          <Typography variant="h3">Record Implant Usage</Typography>
        </div>

        <div className="content-container">
          <Typography variant="h2" className="description">
            {implant.deviceDescription}
          </Typography>

          <Typography variant="body1" className="confirmation-message">
            {isSingleImplant
              ? 'Was this implant used or wasted?'
              : 'How many implants were used or wasted?'}
          </Typography>

          <Box className="status-selector">
            <Typography variant="body1" className="status-label">
              Status:
            </Typography>
            <ToggleButtonGroup
              value={isWasted}
              exclusive
              onChange={(_, value) => value !== null && setIsWasted(value)}
              aria-label="implant status"
              className="status-toggle"
            >
              <ToggleButton value={false} aria-label="implanted">
                Implanted
              </ToggleButton>
              <ToggleButton value={true} aria-label="wasted">
                Wasted
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {!isSingleImplant && (
            <Box className="count-selector">
              <Typography variant="body1" className="count-label">
                Select quantity:
              </Typography>

              <Box className="number-input-container">
                <NumberInput
                  aria-label="Quantity"
                  min={1}
                  max={maxCount}
                  value={usageCount}
                  onChange={(event, val) => setUsageCount(val as number)}
                />
              </Box>

              <Typography variant="body2" className="count-info">
                {usageCount} of {maxCount} available
              </Typography>
            </Box>
          )}
        </div>

        {isLoading && (
          <div className="loading-wrapper">
            <span className="loading-text-wrapper">
              <CircularProgress size="0.8em" className="spinner" />
              <p className="loading-text">Processing</p>
            </span>
          </div>
        )}

        <div className="buttons_container">
          <LoadingButton
            disabled={isLoading}
            loading={false}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </LoadingButton>

          <LoadingButton
            disabled={isLoading}
            loading={isLoading}
            variant="contained"
            color="primary"
            onClick={handleConfirm}
          >
            Record Usage
          </LoadingButton>
        </div>
      </div>
    </Modal>
  )
}

export default UsageCustomImplantModal
